import { useState, useCallback } from 'react';
import useAttributesAllergensApi from './useAttributesAllergensApi';
import { MasterAttribute } from '../types';

const useAttributesList = () => {
  const { getAttributes } = useAttributesAllergensApi();
  const [attributes, setAttributes] = useState<MasterAttribute[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadAttributes = useCallback(async (search: string, category: string, page: number, pageSize: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getAttributes(search, category, page, pageSize);
      setAttributes(response.data);
      setTotalCount(response.totalCount);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load attributes');
      setAttributes([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  }, [getAttributes]);

  return { attributes, totalCount, isLoading, error, loadAttributes };
};

export default useAttributesList;
